export const OrdersTag = {
  oneOrder: 'Pedido: <b>{orders}</b>',
  manyOrders: 'Pedidos: <b>{orders}</b>',
  deliveryTag: ', com entrega a {date}',
  collectedTag: ', com recolha prevista a {date}'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/OrdersTag.js